import styled from 'styled-components';

export function Spinner({
    centered,
    className,
    height,
    width,
    loadingLabel,
}: {
    className?: string;
    loadingLabel?: string;
    centered?: boolean;
    height?: string;
    width?: string;
}) {
    return (
        <Svg
            lang="en"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            $centered={centered}
            $height={height}
            $width={width}
            role="status"
            aria-label={loadingLabel || 'Loading'}
        >
            <path
                d="M8 4C8.9375 3.33333 11.75 2 15.5 2C19.25 2 22.0625 3.33333 23 4"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
            />
            <circle cx="26.5" cy="7.5" r="1.5" fill="currentColor" />
        </Svg>
    );
}

const Svg = styled.svg<{
    $centered?: boolean;
    $width?: string;
    $height?: string;
}>`
    width: ${({ $width }) => $width ?? '18px'};
    height: ${({ $height }) => $height ?? '18px'};
    margin: 0 ${(props) => (props.$centered ? 'auto' : 0)};

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(359deg);
        }
    }
    animation: spin 1.7s linear infinite;
`;
